module.exports = __webpack_public_path__ + "45b4911721b4a31ce6ddced7f5bb0404.png";